import P from "prop-types";
import * as S from "../styles";

import { BarChartCard } from "../../ChartCards/BarChartCard";
import { ComplexPieChartCard } from "../../ChartCards/ComplexPieChartCard";
import { HorizontalBarChartCard } from "../../ChartCards/HorizontalBarChartCard";
import { MapaNordesteChartCard } from "../../ChartCards/MapaNordesteChartCard";
import { SimplePieChartCard } from "../../ChartCards/SimplePieChartCard";
import { HorizontalZoomBarChartCard } from "../../ChartCards/HorizontalZoomBarChartCard";

import { dadosGraficos } from "../../dados";

export function Capitulo1({ currentIndex }) {
  const chartStyle = {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  if (currentIndex !== 1) {
    return <></>;
  } else {
    return (
      <S.Container>
        <S.Container2>
          <S.Grid>
            <HorizontalZoomBarChartCard
              grid
              title="Profissão"
              dados={dadosGraficos.grafico01}
              style={chartStyle}
            />
            <SimplePieChartCard
              title="Gênero"
              dados={dadosGraficos.grafico02}
              style={chartStyle}
              grid
            />
          </S.Grid>

          <BarChartCard
            title="Idade"
            dados={dadosGraficos.grafico03}
            style={chartStyle}
          />

          <S.Grid>
            <BarChartCard
              title="Cor/Raça"
              grid
              dados={dadosGraficos.grafico04}
              style={chartStyle}
            />
            <MapaNordesteChartCard
              grid
              title="Estado em que atua"
              dados={dadosGraficos.grafico05}
              style={chartStyle}
            />
          </S.Grid>

          <HorizontalBarChartCard
            title="Renda líquida"
            dados={dadosGraficos.grafico07}
            style={chartStyle}
          />

          <S.Grid>
            <ComplexPieChartCard
              grid
              title="Atua em região metropolitana ou interior"
              dados={dadosGraficos.grafico06}
              colorPallet={["#071242", "#FBBC56", "#0B4F6C"]}
              style={chartStyle}
            />

            <SimplePieChartCard
              grid
              title="Possui outra atividade remunerada"
              style={chartStyle}
              dados={dadosGraficos.grafico09}
            />
          </S.Grid>

          <BarChartCard
            title="Escolaridade"
            dados={dadosGraficos.grafico10}
            style={chartStyle}
          />
        </S.Container2>
      </S.Container>
    );
  }
}

Capitulo1.propTypes = {
  currentIndex: P.number.isRequired,
};
